import axios from "axios";

export default {
  async all(params, instanceId) {
    let result = await axios.get(
      `/api/v1/instances/${instanceId}/message-templates`,
      {
        params: params
      }
    );
    return result.data.data;
  },
  async find(id, instanceId, params) {
    let result = await axios.get(
      `/api/v1/instances/${instanceId}/message-templates/${id}`,
      {
        params: params
      }
    );
    return result.data.data;
  },
  async create(payload, instanceId) {
    let result = await axios.post(
      `/api/v1/instances/${instanceId}/message-templates`,
      payload
    );
    return result.data.data;
  },
  async update(payload, instanceId, id) {
    let result = await axios.patch(
      `/api/v1/instances/${instanceId}/message-templates/${id}`,
      payload
    );
    return result.data.data;
  },
  async delete(instanceId, id) {
    let result = await axios.delete(
      `/api/v1/instances/${instanceId}/message-templates/${id}`
    );
    return result.data.data;
  },
  async uploadFile(payload, instanceId, id) {
    let result = axios
      .post(`/api/v1/instances/${instanceId}/message-templates/${id}/upload`, payload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

    return result;
  },
  async sendMessage(payload, instanceId) {
    let result = await axios.post(
      `/api/v1/instances/${instanceId}/message/send`,
      payload
    );
    return result.data.data;
  },
}
